import { render, staticRenderFns } from "./OpenClaw.vue?vue&type=template&id=73f8b120&scoped=true"
import script from "./OpenClaw.vue?vue&type=script&lang=js"
export * from "./OpenClaw.vue?vue&type=script&lang=js"
import style0 from "./OpenClaw.vue?vue&type=style&index=0&id=73f8b120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f8b120",
  null
  
)

export default component.exports